import React from 'react';
import { useNavigate } from 'react-router-dom';

const ChangePasswordSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="govuk-width-container mt-10">
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-three-quarters">
          <div className="govuk-panel govuk-panel--confirmation">
            <h1 className="govuk-panel__title">
              Your password has now been reset
            </h1>
            <div className="govuk-panel__body" />
          </div>
          <p className="govuk-body">Please sign in to continue</p>
          <button
            type="submit"
            className="govuk-button"
            data-module="govuk-button"
            onClick={() => navigate('/login')}
          >
            Sign in with your new password &gt;
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordSuccess;
